<template>
    <button 
        :value="tabId"
        :class="{active: isActive}"
        :style="cssAttrs"
        @click="onButtonClick"
    >
        <h3><span v-if="isTabletScreen">0{{ num }}</span> {{ tabCaption.toUpperCase() }}</h3>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: ['color', 'isActive', 'num', 'tabCaption', 'tabId'],
    computed: {
        ...mapGetters(['isTabletScreen', 'screenWidth']),
        cssAttrs() {
            return {
                '--background-color': this.color
            }
        }
    },

    methods: {
        onButtonClick(e) {
            this.$emit('onClick', e.target.closest('button').value);
        }
    }
}

</script>

<style scoped>
h3 { 
    margin: 0;
}

button {
    background: transparent;
    border: solid 1px #838391;
    color: #FFF;
    font-family: "Spartan", sans-serif;
    font-weight: bold;
    font-size: 12px;
    height: 48px;
    letter-spacing: 2.57px;
    line-height: 25px;
    outline: none;    
    padding: 11px 28px;
    text-align: left;
    vertical-align: middle;
    width: 350px;
}

button:hover {
    cursor: pointer;
}

button:hover:not(.active){
    background-color: #38384F;
}

span {
    color: #838391;
}

.active {
    background-color: var(--background-color);
}

@media screen and (max-width: 767px) {
    button {
        background: transparent;
        border: none;
        border-bottom: solid 4px transparent;
        color: #838391;
        font-size: 9px;
        letter-spacing: 1.93px;
        height: 100%;
        max-width: 80px;
        padding: 0;
        text-align: center;
    }

    .active {
        background-color: transparent;
        border-bottom-color: var(--background-color);
    }
}

@media screen and (min-width: 768px) and (max-width: 1199px){
    button {
        font-size: 9px;
        height: 40px;
        letter-spacing: 1.93px;
        padding-top: 7px;
        width: 281px;
    }
}

</style>